<app-grid-container class="contact-details">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column [md]="6" [xs]="3">
          <div class="contact-details__go-back">
            <i class="fa-solid fa-arrow-left"></i>
            <button
              (click)="navigateBack()"
              class="contact-details__go-back-btn"
              type="button"
            >
              {{ "CONTACT_DETAILS_PAGE_BACK_LABEL" | translate }}
            </button>
          </div>
        </app-grid-column>
        <app-grid-column [md]="6" [xs]="9">
          <app-progression-steps />
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column>
          <h1 class="contact-details__title">
            {{ "CONTACT_DETAILS_PAGE_TITLE" | translate }}
          </h1>
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column>
          <app-contact-details-form
            (submitted)="onFormSubmit($event)"
          />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>

  <app-grid-row>
    <app-grid-column>
      <app-basket-sticky-wrapper>
        <app-basket />
      </app-basket-sticky-wrapper>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
